// Service Worker registration module.
// Registers the Workbox-powered /sw.js on app load and provides update detection.

export function register(onUpdate) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .then((registration) => {
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New SW installed while old one still controls — this is an update
                  console.log('[SW] New version available');
                  if (onUpdate) onUpdate(registration);
                } else {
                  // First install — no toast needed
                  console.log('[SW] App cached for offline use');
                }
              }
            });
          });
        })
        .catch((error) => {
          console.error('[SW] Registration failed:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
